import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const ColossusOfRhodes = {
  id: '60',
  name: 'Colossus of Rhodes',
  era: EraType.bronzeAge,
  icon: 'cr',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.NAVAL | WonderKind.STATUE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GEARS_FROM_WONDER_CONTRIBUTION_MOD,
      EffectAmount.asPerLevel([
        5,
        9,
        12,
        15,
        17,   // 5
        18,
        19,
        20,
        21,
        22, // 10
        23,
        24,
        25,
        26,
        27,   // 15
        28,
        29,
        30,
        31,
        32, // 20
        33,
        34,
        35,
        36,
        37,   // 25
        38,
        39,
        40,
        41,
        42  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asCallbackWithLevel(
          function (level) {
            if (level === 30) {
              return 4;
            }
            if (level >= 20) {
              return 3;
            }
            if (level >= 10) {
              return 2;
            }
            return 1;
          }
        )
        .withOutput(ProductionOutputType.TREASURE_HUNT_ATTEMPT)
      ,
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(5).withKind(WonderKind.NAVAL),
      effect: null,
    }
  ],
};

export default ColossusOfRhodes;
